<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">{{$t('apiDoc.在线文档')}}</span>
      <!-- 测试工具已屏蔽
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span>
      -->
    </div>
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 测试工具已屏蔽
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";
// import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'customs/addOrder';
export default {
  components: { onlineDoc },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,
      onlineData: {
        apiDesc: `${this.$t('customsDoc.addOrderDesc')}`,
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList: [
          {
            title: `${this.$t('onlineDoc.Headers')}`,
            value: [
              {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
              {name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`},
              {name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
            ]
          },
          {
            title: `${this.$t('onlineDoc.请求参数')}`,
            value: [
              {name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`},
            ]
          },
          {
            title: `${this.$t('onlineDoc.业务参数')}`,
            value: [
              {name: "customerCode", type: "String", require: "Y", normal: "J0086474299", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
              {name: "digest", type: "String", require: "Y", normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`, describe: `${this.$t('customsDoc.digestDesc')}`},
              {name: "mawbs", type: "Array", require: "Y", normal: "", describe: `${this.$t('customsDoc.mawbs')}`},
            ]
          },
          {
            title: `${this.$t('customsDoc.mawbs')}`,
            value: [
              {name: "customerCode", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
              {name: "customerName", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.customerName')}`},
              {name: "waybillId", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.waybillId')}`},
              {name: "flightNo", type: "String(10)", require: "N", normal: "", describe: `${this.$t('customsDoc.flightNo')}`},
              {name: "estimatedTransitTime", type: "LocalDateTime", require: "N", normal: "", describe: `${this.$t('customsDoc.estimatedTransitTime')}`},
              {name: "estimatedArrivalTime", type: "LocalDateTime", require: "N", normal: "", describe: `${this.$t('customsDoc.estimatedArrivalTime')}`},
              {name: "departPortCode", type: "String(3)", require: "N", normal: "", describe: `${this.$t('customsDoc.departPortCode')}`},
              {name: "arrivePortCode", type: "String(3)", require: "N", normal: "", describe: `${this.$t('customsDoc.arrivePortCode')}`},
              {name: "masterWaybillNo", type: "String(20)", require: "N", normal: "", describe: `${this.$t('customsDoc.masterWaybillNo')}`},
              {name: "totalWeight", type: "Double", require: "N", normal: "", describe: `${this.$t('customsDoc.totalWeight')}`},
              {name: "anvisaNo", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.anvisaNo')}`},
              {name: "customerOrderId", type: "String(28)", require: "Y", normal: "", describe: `${this.$t('customsDoc.customerOrderId')}`},
              {name: "serviceType", type: "String", require: "Y", normal: "ST", describe: `${this.$t('customsDoc.serviceType')}`},
              {name: "goodsShortDescription", type: "String(480)", require: "Y", normal: "", describe: `${this.$t('customsDoc.goodsShortDescription')}`},
              {name: "freight", type: "BigDecimal(8,2)", require: "Y", normal: "", describe: `${this.$t('customsDoc.freight')}`},
              {name: "insurance", type: "BigDecimal(8,2)", require: "N", normal: "", describe: `${this.$t('customsDoc.insurance')}`},
              {name: "packageWeight", type: "Number", require: "Y", normal: "", describe: `${this.$t('customsDoc.packageWeight')}`},
              {name: "totalPackage", type: "Long", require: "N", normal: "", describe: `${this.$t('customsDoc.totalPackage')}`},
              {name: "paymentMode", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.paymentMode')}`},
              {name: "boxNo", type: "String(20)", require: "Y", normal: "", describe: `${this.$t('customsDoc.boxNo')}`},
              {name: "codeEce", type: "String(35)", require: "Y", normal: "", describe: `${this.$t('customsDoc.codeEce')}`},
              {name: "nameEce", type: "String(100)", require: "Y", normal: "", describe: `${this.$t('customsDoc.nameEce')}`},
              {name: "EstimateCBS", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.EstimateCBS')}`},
              {name: "EstimatedIBSMunicipality", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.EstimatedIBSMunicipality')}`},
              {name: "EstimatedIBSState", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.EstimatedIBSState')}`},
              {name: "estimatedDarf", type: "BigDecimal", require: "Y", normal: "", describe: `${this.$t('customsDoc.estimatedDarf')}`},
              {name: "estimatedGnre", type: "BigDecimal", require: "Y", normal: "", describe: `${this.$t('customsDoc.estimatedGnre')}`},
              {name: "receiverAdditionalInfo", type: "String(80)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverAdditionalInfo')}`},
              {name: "receiverStreet", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverStreet')}`},
              {name: "receiverAreaId", type: "Integer", require: "N", normal: "", describe: `${this.$t('customsDoc.receiverAreaId')}`},
              {name: "receiverAreaName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverAreaName')}`},
              {name: "receiverCityId", type: "Integer", require: "N", normal: "", describe: `${this.$t('customsDoc.receiverCityId')}`},
              {name: "receiverCityName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverCityName')}`},
              {name: "receiverProvinceId", type: "Integer", require: "N", normal: "", describe: `${this.$t('customsDoc.receiverProvinceId')}`},
              {name: "receiverProvinceName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverProvinceName')}`},
              {name: "receiverCountry", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.receiverCountry')}`},
              {name: "receiverCountryIso", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverCountryIso')}`},
              {name: "receiverPostalCode", type: "String(15)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverPostalCode')}`},
              {name: "receiverIdNumber", type: "String(14)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverIdNumber')}`},
              {name: "receiverIdType", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverIdType')}`},
              {name: "receiverName", type: "String(70)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverName')}`},
              {name: "receiverEmail", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverEmail')}`},
              {name: "receiverMobilePhone", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.receiverMobilePhone')}`},
              {name: "senderAdditionalInfo", type: "String(94)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderAdditionalInfo')}`},
              {name: "senderStreet", type: "String(97)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderStreet')}`},
              {name: "senderAreaId", type: "Integer", require: "N", normal: "", describe: `${this.$t('customsDoc.senderAreaId')}`},
              {name: "senderAreaName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderAreaName')}`},
              {name: "senderCityId", type: "Integer", require: "N", normal: "", describe: `${this.$t('customsDoc.senderCityId')}`},
              {name: "senderCityName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderCityName')}`},
              {name: "senderProvinceId", type: "Integer", require: "N", normal: "", describe: `${this.$t('customsDoc.senderProvinceId')}`},
              {name: "senderProvinceName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderProvinceName')}`},
              {name: "senderCountry", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.senderCountry')}`},
              {name: "senderCountryIso", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderCountryIso')}`},
              {name: "senderPostalCode", type: "String(15)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderPostalCode')}`},
              {name: "senderIdNumber", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.senderIdNumber')}`},
              {name: "senderIdType", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.senderIdType')}`},
              {name: "senderName", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.senderName')}`},
              {name: "senderEmail", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.senderEmail')}`},
              {name: "senderMobilePhone", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.senderMobilePhone')}`},
              {name: "omsCustomsGoods", type: "Array", require: "Y", normal: "", describe: `${this.$t('customsDoc.omsCustomsGoods')}`},
            ]
          },
          {
            title: `${this.$t('customsDoc.omsCustomsGoods')}`,
            value: [
              {name: "codElementoNcm", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.codElementoNcm')}`},
              {name: "cClassTrib", type: "String", require: "Y", normal: "410009", describe: `${this.$t('customsDoc.cClassTrib')}`},
              {name: "comercialValue", type: "BigDecimal", require: "Y", normal: "", describe: `${this.$t('customsDoc.comercialValue')}`},
              {name: "currency", type: "Integer", require: "Y", normal: "", describe: `${this.$t('customsDoc.currency')}`},
              {name: "enquadramento", type: "Integer", require: "Y", normal: "", describe: `${this.$t('customsDoc.enquadramento')}`},
              {name: "goodsDescription", type: "String(300)", require: "Y", normal: "", describe: `${this.$t('customsDoc.goodsDescription')}`},
              {name: "goodsWeight", type: "BigDecimal", require: "Y", normal: "", describe: `${this.$t('customsDoc.goodsWeight')}`},
              {name: "height", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('customsDoc.height')}`},
              {name: "len", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('customsDoc.len')}`},
              {name: "width", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('customsDoc.width')}`},
              {name: "ncmCode", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.ncmCode')}`},
              {name: "quantity", type: "Integer", require: "Y", normal: "", describe: `${this.$t('customsDoc.quantity')}`},
              {name: "sku", type: "String", require: "N", normal: "", describe: `${this.$t('customsDoc.sku')}`},
            ]
          }
        ],
        responseDataList: [
          {
            title: `${this.$t('onlineDoc.响应参数')}`,
            value: [
              {name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}`},
              {name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}`},
              {name: "data", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}`},
            ]
          },
          {
            title: `${this.$t('onlineDoc.data类型说明')}`,
            value: [
              {name: "customerOrderId", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.customerOrderId')}`},
              {name: "waybillId", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.waybillId')}`},
              {name: "success", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.successLabel')}`},
              {name: "terminalDispatchCode", type: "String", require: "Y", normal: "SP002 662 001", describe: `${this.$t('customsDoc.terminalDispatchCode')}`},
              {name: "serviceProvider", type: "String", require: "Y", normal: "J&T express", describe: `${this.$t('customsDoc.serviceProviderLabel')}`},
              {name: "timeZone", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.timeZoneLabel')}`},
            ]
          }
        ],
        requestCode: `{
    "customerCode": "J0086024185",
    "digest": "BlZv+NBMfmAC+oHjfHk7Yw==",
    "mawbs": [
        {
            "arrivePortCode": "GRU",
            "departPortCode": "MIA",
            "flightNo": "MU12396",
            "estimatedTransitTime": "2024-12-14T00:00:01-03:00",
            "estimatedArrivalTime": "2024-12-15T00:00:01-03:00",
            "masterWaybillNo": "TD-30611843",
            "EstimateCBS": 22.33,
            "EstimatedIBSMunicipality": 333.33,
            "EstimatedIBSState": 566.44,
            "boxNo": "box050530611843",
            "totalWeight": 1,
            "customerOrderId": "test30611843_1781760902313",
            "serviceType": "ST",
            "goodsShortDescription": "1",
            "freight": 2,
            "totalPackage": 1,
            "packageWeight": 10,
            "comercialDestination": 0,
            "paymentMode": "",
            "codeEce": "1234",
            "nameEce": "Nome Empresa",
            "estimatedDarf": 1,
            "estimatedGnre": 1,
            "customerCode": "J0086024185",
            "customerName": "test",
            "receiverAdditionalInfo": "Room 1201,No. 780,Lane 998,Chaoyang District,BeijingRoom 1201,No. 780,1128785856",
            "receiverStreet": "1",
            "receiverAreaName": ".",
            "receiverCityName": "Anadia",
            "receiverProvinceName": "AL",
            "receiverPostalCode": "13476564",
            "receiverCountry": "BR",
            "receiverCountryIso": "BR",
            "receiverIdNumber": "12345678901234",
            "receiverIdType": "3",
            "receiverName": "Room 1201,No. 780,Lane ,Lane 998,Chaoyang yang",
            "receiverMobilePhone": "+8615601795090",
            "receiverEmail": "kb@qq.com",
            "senderAdditionalInfo": "Room 1201,No. 780,Lane 998,Chaoyang District,BeijingRoom 1201,No. 780,1128785856",
            "senderStreet": "senderStreet",
            "senderAreaName": "senderAreaName",
            "senderCityName": "senderCityName",
            "senderProvinceName": "senderProvinceName",
            "senderCountry": "CN",
            "senderCountryIso": "CN",
            "senderPostalCode": "89883000",
            "senderIdNumber": "",
            "senderIdType": "",
            "senderName": "james",
            "senderMobilePhone": "+8615601795090",
            "senderEmail": "zms@qq.com",
            "omsCustomsGoods": [
                {
                    "codElementoNcm": "111",
                    "cClassTrib ": "410009",
                    "ncmCode": "961700",
                    "comercialValue": 2,
                    "currency": "790",
                    "goodsDescription": "1",
                    "goodsWeight": "1",
                    "len": 1,
                    "width": 1,
                    "height": 1,
                    "quantity": 1,
                    "sku": "1234",
                    "enquadramento": 17
                }
            ]
        }
    ]
}`,
        responseCode: { "code": "1", "msg": "success", "data": [{"customerOrderId": "temu00007654328323","waybillId": "U88000138271998","success": true,"terminalDispatchCode": "SP002 662 001","serviceProvider": "J&T express","timeZone": "GMT-03:00"}] },
        errcodeJson: []
      },
      // apiTestData 已屏蔽
      // apiTestData: { ... }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>@import "../../css/apiTest.scss";</style>